








































import { defineComponent, PropType } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { useUser }                   from '@/views/users/hooks/use-user';
import { useSidePanel }              from '@/views/users/hooks/use-side-panel';
import { User }                      from '@/views/users/users.types';
import cIconTrashCan                 from '@/components/icons/icon-trash-can.component.vue';
import cIconEdit                     from '@/components/icons/icon-edit.component.vue';
import cIconLock                     from '@/components/icons/icon-lock.component.vue';

export default defineComponent({
  name: 'cUserTile',
  components: {
    cIconEdit,
    cIconTrashCan,
    cIconLock,
  },
  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
  setup() {
    const { i18n } = useGlobals();
    const { showEditPasswordFormPanel, showEditUserFormPanel } = useSidePanel();
    const { removeUser } = useUser();

    return {
      i18n,
      showEditUserFormPanel,
      showEditPasswordFormPanel,
      removeUser,
    };
  },
});
